<template>
  <div style="padding: 10px">
    <x-table
      listApi="biz.warehouse.order.info.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无订单信息"
      defaultSort="order_time desc"
      :fieldList="fieldList"
      :actionList="actionList"
      :defaultParams="defaultParams"
      :actionWidth="100"
    >
      <template slot="row-info" slot-scope="scope">
        <warehouse-order-info :orderInfo="scope.row" />
      </template>
    </x-table>
  </div>
</template>

<script>
import detailPage from "../../warehouse/warehouse-order/detail.vue";
import WarehouseOrderInfo from "../../../../components/business/warehouseOrderInfo.vue";

export default {
  components: {
    WarehouseOrderInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        noStore: 1,
        skuGuid: this.pageQuery.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "订单信息",
          minWidth: "220",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "商品信息详情",
              refresh,
              component: detailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
      ],
    };
  },
};
</script>
